class MarqueeScroll extends HTMLElement {
    connectedCallback() {
        this.tracks = Array.from(this.querySelectorAll('[data-track]'));

        this.init();
    }

    init() {
        this.tracks.forEach((track) => {
            const direction = track.dataset.track === 'rtl' ? -1 : 1;

            gsap.set(track, {
                xPercent: 0,
                force3D: true,
            });

            const width = track.scrollWidth;



            gsap.to(track, {
                xPercent: direction === -1 ? -100 : 100,
                duration: width / 50,
                ease: 'none',
                repeat: -1,
                modifiers: {
                    x: (value) => {
                        const current = parseFloat(value);
                        return (current % width) + 'px';
                    },
                },
            });
        });
    }
}

customElements.define('marquee-scroll', MarqueeScroll);